import type { ReactNode } from "react";
import type { OoGameSummary } from "../../hooks/useOoReports";
import css from "./dashboard.module.css";

/**
 * «Отчёты друг о друге» в карточке игры дашборда ОО: тексты «Автор → о ком» (27.08 — сразу, целиком) и
 * запрошенные, но ещё не заполненные пары. 13.10 (владелец: «показывать сразу»): блок виден и у игры без
 * основного отчёта — игроки учебной игры пишут из кабинета раньше, чем операторы сдают отчёт игры.
 * Иконки — дашборда (person/arrow), чтобы блок выглядел как раньше.
 */
export function PeerTextsBlock({ game, person, arrow }: { game: Pick<OoGameSummary, "peerTexts" | "peers">; person: ReactNode; arrow: ReactNode }) {
  if (game.peerTexts.length === 0 && game.peers.length === 0) return null;
  return (
    <div className={css.detPeers}>
      <div className={css.detH}>Отчёты друг о друге</div>
      {game.peerTexts.map((p, i) => (
        <div key={`pt${i}`} className={css.peerTextRow}>
          <div className={css.peerRow}>
            <span className={css.peerIco}>{person}</span>
            <span className={css.peerAuthor}>{p.author}</span>
            <span className={css.peerArrow}>{arrow}</span>
            <span className={css.peerSubject}>о {p.subject ?? "ком угодно"}</span>
          </div>
          {p.activity ? <div className={css.peerBody}>{p.activity}</div> : null}
          {p.impression ? <div className={css.peerBody}>{p.impression}</div> : null}
        </div>
      ))}
      {game.peers
        .filter((req) => !game.peerTexts.some((t) => t.author === req.authorName && (t.subject ?? null) === (req.subjectName ?? null)))
        .map((peer, i) => (
          <div key={`pr${i}`} className={css.peerRow}>
            <span className={css.peerIco}>{person}</span>
            <span className={css.peerAuthor}>{peer.authorName}</span>
            <span className={css.peerArrow}>{arrow}</span>
            <span className={css.peerSubject}>о {peer.subjectName ?? "ком угодно"}</span>
            <span className={css.peerPending}>— ещё не заполнено</span>
          </div>
        ))}
    </div>
  );
}
